import React from "react";
import { Grid } from "@mui/material";
import DescriptionActivite from "../shared/DescriptionActivite";
import OutilTelemedecine from "../shared/OutilTelemedecine";
import DocumentsExiges from "../shared/DocumentsExiges";
import DemandesAutourPatient from "../shared/DemandesAutourPatient";
import { FormulaireSollicitation } from "../shared/FormulaireSollicitation";
import { useAppSelector } from "../../store";
import LienDemandeAppui from "../shared/LienDemandeAppui";
import MethodesContactMSDemandeAppui from "../shared/MethodesContactMSDemandeAppui";

export function EquipeRessource() {
	const { preferences, useMonSisra } = useAppSelector((s) => s.expertise);

	const components = React.useMemo(() => {
		let elements = [];
		if (preferences?.statutDansAnnuaire) {
			elements.push(<LienDemandeAppui />, <DescriptionActivite />, <MethodesContactMSDemandeAppui />, <OutilTelemedecine />);

			if (useMonSisra) {
				elements.push(<DocumentsExiges />, <DemandesAutourPatient />);

				if (preferences?.centragePatient) {
					elements.push(<FormulaireSollicitation />);
				}
			} else {
				elements.push(<DemandesAutourPatient />);
			}
		}
		return elements;
	}, [preferences, useMonSisra]);

	return (
		<Grid container item sx={{ height: "100%" }} direction={"column"} spacing={2}>
			{components.map((comp, i) => (
				<Grid key={i} item>
					{comp}
				</Grid>
			))}
		</Grid>
	);
}
